(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velle-iron-v2"] && !Shopify.designMode) return;
  try {
    
function initVelleV2(scope=document){
  scope.querySelectorAll('[data-velle-v2]').forEach(root=>{
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';root.classList.add('vv-ready');
    const form=root.querySelector('.vv-product-form');
    const mask=root.querySelector('[data-mask-id]');
    const labels=root.querySelectorAll('[data-cta-label]');
    const buttons=root.querySelectorAll('.vv-button');
    const sticky=root.querySelector('[data-sticky]');
    const error=root.querySelector('[data-form-error]');
    const mainButton=root.querySelector('.vv-main-cta');
    const isAvailable=!mainButton.disabled;
    let busy=false;
    const update=()=>{const price=mask?.checked?root.dataset.pairPrice:root.dataset.basePrice;if(isAvailable)labels.forEach(el=>el.textContent=`${root.dataset.addLabel} — ${price}`);root.querySelector('[data-sticky-price]').textContent=price;root.querySelector('[data-sticky-name]').textContent=mask?.checked?root.dataset.pairLabel:root.dataset.ironLabel;};
    mask?.addEventListener('change',update);root.querySelector('[data-pair-add]')?.addEventListener('click',()=>{if(mask){mask.checked=true;update();form.requestSubmit();}});
    root.querySelectorAll('[data-gallery-target]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-gallery-panel]').forEach(panel=>panel.hidden=panel.dataset.galleryPanel!==button.dataset.galleryTarget);root.querySelectorAll('[data-gallery-target]').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));}));
    sticky.hidden=false;
    const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>sticky.classList.toggle('is-visible',!entry.isIntersecting));},{threshold:0});observer.observe(mainButton);
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(busy||!isAvailable)return;
      busy=true;error.hidden=true;buttons.forEach(button=>button.disabled=true);labels.forEach(el=>el.textContent=root.dataset.busyLabel);
      const items=[{id:form.querySelector('[name="id"]').value,quantity:1}];
      if(mask?.checked)items.push({id:mask.dataset.maskId,quantity:1});
      try{
        const response=await fetch(root.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||root.dataset.errorLabel);
        window.location.assign(root.dataset.cartUrl);
      }catch(err){error.textContent=err.message||root.dataset.errorLabel;error.hidden=false;error.scrollIntoView({block:'center',behavior:'smooth'});busy=false;buttons.forEach(button=>button.disabled=!isAvailable);update();}
    });
    window.addEventListener('pageshow',()=>{busy=false;buttons.forEach(button=>button.disabled=!isAvailable);update();});
  });
}
initVelleV2();document.addEventListener('shopify:section:load',event=>initVelleV2(event.target));

  } catch(e) { console.error(e); }
})();
})();
